(function () {
  angular.module('calendarApp').directive('costPopover', ["API_URL", "$timeout", function (API_URL, $timeout) {
    return {
      restrict: 'AE',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/cost-popover.html',
      scope: {
        costs: '='
      },
      link: function link(scope, elem, attrs) {
        function uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
          });
        }

        scope.currencySettings = smooth.currencySettings;
        scope.popoverID = uuidv4();
        $timeout(function () {
          $('#' + scope.popoverID).popover({
            'container': '.days-display',
            'content': $('.popover-content', elem).html(),
            'placement': 'auto',
            'html': true,
            'trigger': 'hover'
          });
        }, 0);
      }
    };
  }]); // End directive
})();